/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CurrencyCode = {
    Eur: 'EUR',
    Gbp: 'GBP',
    Usd: 'USD'
} as const;
export type CurrencyCode = typeof CurrencyCode[keyof typeof CurrencyCode];


export function instanceOfCurrencyCode(value: any): boolean {
    for (const key in CurrencyCode) {
        if (Object.prototype.hasOwnProperty.call(CurrencyCode, key)) {
            // @ts-ignore
            if (CurrencyCode[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CurrencyCodeFromJSON(json: any): CurrencyCode {
    return CurrencyCodeFromJSONTyped(json, false);
}

export function CurrencyCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyCode {
    return json as CurrencyCode;
}

export function CurrencyCodeToJSON(value?: CurrencyCode | null): any {
    return value as any;
}

